import request from "../../../../utils/api";

const url = "api/v1/users";

export const getCompanies = (id, params) => {
  return request(`${url}/${id}/companies`, { params });
}

export const createCompany = (id, body) => {
  return request(`${url}/${id}/companies`, { method: "post", body });
}

export const updateCompany = (customer_id, company_id, body) => {
  return request(`${url}/${customer_id}/companies/${company_id}`, { method: "put", body });
}

export const deleteCompany = (customer_id, company_id) => {
  return request(`${url}/${customer_id}/companies/${company_id}`, { method: "delete" });
}

export const getCompanyDetails = (customer_id, company_id) => {
  return request(`${url}/${customer_id}/companies/${company_id}`)
}


// WEBPACK FOOTER //
// ./src/modules/company/pages/company/service.js